export default "__VITE_ASSET__CTiVlBdT__"